<template>
  <v-app style="background-color: #eaeaea">
    <v-main v-if="$route.meta.layout === 'fullscreen'">
      <router-view></router-view>
    </v-main>

    <div v-if="$route.meta.layout === 'menu'">
      <v-progress-linear app indeterminate color="deep-purple lighten-3" class="loading-bar" v-show="showLoading"></v-progress-linear>

      <v-navigation-drawer class="drawer" v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" width="270" app>
        <center class="avatar_container mt-6 mb-6">
          <div class="avatar">
            <img src="@/assets/l_branco.png" width="180" />
          </div>
          <h4 class="icon">{{ user && user.name ? user.name : projectName }}</h4>
        </center>
        <v-divider />

        <v-list dense>
          <v-list-item :to="user?._id ? '/meu-perfil' : null" link @click="checkAction">
            <v-list-item-action class="item_icon">
              <v-icon class="icon">mdi-account-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="menu-item">Meu perfil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="user?._id ? '/carros' : null" link @click="checkAction">
            <v-list-item-action class="item_icon">
              <v-icon class="icon">mdi-car</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="menu-item">Carros</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="user?._id ? '/cadastrar-carro-lojista' : null" link @click="checkAction" v-if="user && user.is_car_dealer">
            <v-list-item-action class="item_icon">
              <v-icon class="icon">mdi-plus</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="menu-item">Cadastro de carros</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list>
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-title class="menu-item">Páginas úteis</v-list-item-title>
              </template>
              <template v-slot:prependIcon>
                <v-icon class="icon">mdi-information-outline</v-icon>
              </template>

              <v-list-item class="pointer" @click.native="dialogHelpCenter = true">
                <v-list-item-icon class="item_icon">
                  <v-icon class="icon">mdi-help-circle-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-title class="menu-item">Central de ajuda</v-list-item-title>
              </v-list-item>

              <v-list-item class="pointer" @click.native="dialogTerms = true">
                <v-list-item-icon class="item_icon">
                  <v-icon class="icon">mdi-file-document-check-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-title class="menu-item">Termos de uso</v-list-item-title>
              </v-list-item>


              <v-list-item class="pointer" @click.native="dialogTips = true">
                <v-list-item-icon>
                  <v-icon class="icon">mdi-lock-check</v-icon>
                </v-list-item-icon>

                <v-list-item-title class="menu-item">Dicas de segurança</v-list-item-title>
              </v-list-item>


              <v-list-item class="pointer" @click.native="dialogAbout = true">
                <v-list-item-icon>
                  <v-icon class="icon">mdi-information-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-title class="menu-item">Sobre o Clube</v-list-item-title>
              </v-list-item>

            </v-list-group>
          </v-list>

          <v-list v-if="user && user.admin">
            <v-list-group>
              <template v-slot:activator>
                <v-list-item-title class="menu-item">Administração</v-list-item-title>
              </template>
              <template v-slot:prependIcon>
                <v-icon class="icon">mdi-cog-outline</v-icon>
              </template>

              <router-link to="/dashboard" v-if="user && user.superadmin">
                <v-list-item>
                  <v-list-item-icon class="item_icon">
                    <v-icon class="icon">mdi-monitor-dashboard</v-icon>
                  </v-list-item-icon>

                  <v-list-item-title class="menu-item">Dashboard</v-list-item-title>
                </v-list-item>
              </router-link>

              <router-link to="/auditoria" v-if="user && user.superadmin">
                <v-list-item>
                  <v-list-item-icon class="item_icon">
                    <v-icon class="icon">mdi-file-find-outline</v-icon>
                  </v-list-item-icon>

                  <v-list-item-title class="menu-item">Auditoria</v-list-item-title>
                </v-list-item>
              </router-link>

              <router-link to="/denuncias">
                <v-list-item>
                  <v-list-item-icon class="item_icon">
                    <v-icon class="icon">mdi-alert-decagram-outline</v-icon>
                  </v-list-item-icon>

                  <v-list-item-title class="menu-item">Denúncias</v-list-item-title>
                </v-list-item>
              </router-link>

              <router-link to="/solicitacoes-lojistas">
                <v-list-item>
                  <v-list-item-icon class="item_icon">
                    <v-icon class="icon">mdi-store-outline</v-icon>
                  </v-list-item-icon>

                  <v-list-item-title class="menu-item">Aprovação de lojista</v-list-item-title>
                </v-list-item>
              </router-link>


              <router-link to="/lojas">
                <v-list-item>
                  <v-list-item-icon class="item_icon">
                    <v-icon class="icon">mdi-store-outline</v-icon>
                  </v-list-item-icon>

                  <v-list-item-title class="menu-item">Lojas</v-list-item-title>
                </v-list-item>
              </router-link>


              <router-link to="/cadastrar-carro">
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon class="icon">mdi-car-arrow-right</v-icon>
                  </v-list-item-icon>

                  <v-list-item-title class="menu-item">Carros</v-list-item-title>
                </v-list-item>
              </router-link>

              <router-link to="/usuarios">
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon class="icon">mdi-account-multiple</v-icon>
                  </v-list-item-icon>

                  <v-list-item-title class="menu-item">Usuários</v-list-item-title>
                </v-list-item>
              </router-link>
            </v-list-group>
          </v-list>

          <router-link to="#">
            <v-list-item @click.native="logout()">
              <v-list-item-action class="item_icon">
                <v-icon class="icon">mdi-exit-run</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="menu-item">Sair</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list>

      </v-navigation-drawer>

      <v-main>
        <v-app-bar color="white" :clipped-left="$vuetify.breakpoint.lgAndUp" dark elevation="2">
          <v-app-bar-nav-icon @click.stop="drawer = !drawer" color="black"></v-app-bar-nav-icon>
          <v-toolbar-title class="toolbar">
            {{ projectName }}
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-menu>
            <template #activator="{ on: menu }">
              <v-btn icon v-on="menu">
                <v-icon color="black">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="$router.push('/meu-perfil')">
                <v-list-item-title class="bar-menu-item-title">
                  <v-icon class="mr-3">mdi-account</v-icon>
                  Meu Perfil
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="logout()">
                <v-list-item-title class="bar-menu-item-title">
                  <v-icon class="mr-3">mdi-exit-run</v-icon>
                  Sair
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-app-bar>
        <v-container fluid class="menu-page-container">
          <router-view fluid />
        </v-container>

        <v-dialog v-model="dialogHelpCenter" max-width="350">
          <v-card>
            <v-card-title class="text-h5">
              Central de Ajuda
            </v-card-title>
            <v-card-text>Oferecemos suporte online via whatsapp. Adicione nosso número e inicie uma
              conversa.</v-card-text>
            <v-card-text>
              <h3><v-icon color="green" class="mr-2">mdi-whatsapp</v-icon>(48) 8864-5540</h3>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#123cd7" text @click="dialogHelpCenter = false;">
                Ok
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogSubscribe" max-width="350">
          <v-card>
            <v-card-title class="text-h5">
              Assine para continuar
            </v-card-title>
            <v-card-text>Faça sua assinatura agora mesmo para obter acesso completo à plataforma</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#123cd7" dark @click="dialogSubscribe = false; openSubscribeLink()">
                Assinar agora
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <v-dialog v-model="dialogTerms" fullscreen hide-overlay persistent transition="dialog-bottom-transition" class="details-container">
          <v-card>
            <v-toolbar dark class="bar-car-details">
              <v-toolbar-title>Termos de uso</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click.native="dialogTerms = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="pt-4" v-html="termos" style="font-size: 24px;"></v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogTips" fullscreen hide-overlay persistent transition="dialog-bottom-transition" class="details-container">
          <v-card>
            <v-toolbar dark class="bar-car-details">
              <v-toolbar-title>Dicas de Segurança</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click.native="dialogTips = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="pt-4" style="font-size: 16px; line-height: 32px;" v-html="dicas">

            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogAbout" fullscreen hide-overlay persistent transition="dialog-bottom-transition" class="details-container">
          <v-card>
            <v-toolbar dark class="bar-car-details">
              <v-toolbar-title>Sobre o Clube do Carro</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click.native="dialogAbout = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="pt-4" style="font-size: 16px; line-height: 32px;" v-html="sobre">
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-main>
    </div>
  </v-app>
</template>

<script>
import Api from "@/lib/Api";
import { v4 as uuidv4 } from 'uuid';
import { getTerms, getDicas, getSobre } from "@/lib/Utils";

export default {
  name: "App",

  data: () => ({
    drawer: false,
    showLoading: false,
    projectName: "Clube do Carro",
    subscribeLink: 'https://go.pagflexy.com.br/subscribe/clube-do-carro-app-br',
    user: { admin: false },
    dialogHelpCenter: false,
    dialogSubscribe: false,
    dialogTerms: false,
    dialogTips: false,
    dialogAbout: false,
    termos: '',
    dicas: '',
    sobre: '',
    gearboxes: [
      { id: 'Manual', name: "Manual" },
      { id: 'Automático', name: "Automático" },
    ],
    fuels: [
      { id: 'Flex', name: "Flex" },
      { id: 'Gasolina', name: "Gasolina" },
      { id: 'Álcool', name: "Álcool" },
      { id: 'Diesel', name: "Diesel" },
      { id: 'Elétrico', name: "Elétrico" },
    ],
    states: [
      { name: "Acre", id: "AC" },
      { name: "Alagoas", id: "AL" },
      { name: "Amapá", id: "AP" },
      { name: "Amazonas", id: "AM" },
      { name: "Bahia", id: "BA" },
      { name: "Ceará", id: "CE" },
      { name: "Distrito Federal", id: "DF" },
      { name: "Espírito Santo", id: "ES" },
      { name: "Goiás", id: "GO" },
      { name: "Maranhão", id: "MA" },
      { name: "Mato Grosso", id: "MT" },
      { name: "Mato Grosso do Sul", id: "MS" },
      { name: "Minas Gerais", id: "MG" },
      { name: "Pará", id: "PA" },
      { name: "Paraíba", id: "PB" },
      { name: "Paraná", id: "PR" },
      { name: "Pernambuco", id: "PE" },
      { name: "Piauí", id: "PI" },
      { name: "Rio de Janeiro", id: "RJ" },
      { name: "Rio Grande do Norte", id: "RN" },
      { name: "Rio Grande do Sul", id: "RS" },
      { name: "Rondônia", id: "RO" },
      { name: "Roraima", id: "RR" },
      { name: "Santa Catarina", id: "SC" },
      { name: "São Paulo", id: "SP" },
      { name: "Sergipe", id: "SE" },
      { name: "Tocantins", id: "TO" },
    ],
    car_brands: [{ "id": 1, "brand": "Acura" }, { "id": 2, "brand": "Agrale" }, { "id": 3, "brand": "Alfa Romeo" }, { "id": 4, "brand": "AM Gen" }, { "id": 5, "brand": "Asia Motors" }, { "id": 189, "brand": "ASTON MARTIN" }, { "id": 6, "brand": "Audi" }, { "id": 207, "brand": "Baby" }, { "id": 7, "brand": "BMW" }, { "id": 8, "brand": "BRM" }, { "id": 123, "brand": "Bugre" }, { "id": 238, "brand": "BYD" }, { "id": 236, "brand": "CAB Motors" }, { "id": 10, "brand": "Cadillac" }, { "id": 161, "brand": "Caoa Chery" }, { "id": 11, "brand": "CBT Jipe" }, { "id": 136, "brand": "CHANA" }, { "id": 182, "brand": "CHANGAN" }, { "id": 12, "brand": "Chrysler" }, { "id": 13, "brand": "Citroën" }, { "id": 14, "brand": "Cross Lander" }, { "id": 241, "brand": "D2D " }, { "id": 15, "brand": "Daewoo" }, { "id": 16, "brand": "Daihatsu" }, { "id": 17, "brand": "Dodge" }, { "id": 147, "brand": "EFFA" }, { "id": 18, "brand": "Engesa" }, { "id": 19, "brand": "Envemo" }, { "id": 20, "brand": "Ferrari" }, { "id": 21, "brand": "Fiat" }, { "id": 149, "brand": "Fibravan" }, { "id": 22, "brand": "Ford" }, { "id": 190, "brand": "FOTON" }, { "id": 170, "brand": "Fyber" }, { "id": 199, "brand": "GEELY" }, { "id": 23, "brand": "GM - Chevrolet" }, { "id": 153, "brand": "GREAT WALL" }, { "id": 24, "brand": "Gurgel" }, { "id": 240, "brand": "GWM" }, { "id": 152, "brand": "HAFEI" }, { "id": 214, "brand": "HITECH ELECTRIC" }, { "id": 25, "brand": "Honda" }, { "id": 26, "brand": "Hyundai" }, { "id": 27, "brand": "Isuzu" }, { "id": 208, "brand": "IVECO" }, { "id": 177, "brand": "JAC" }, { "id": 28, "brand": "Jaguar" }, { "id": 29, "brand": "Jeep" }, { "id": 154, "brand": "JINBEI" }, { "id": 30, "brand": "JPX" }, { "id": 31, "brand": "Kia Motors" }, { "id": 32, "brand": "Lada" }, { "id": 171, "brand": "LAMBORGHINI" }, { "id": 33, "brand": "Land Rover" }, { "id": 34, "brand": "Lexus" }, { "id": 168, "brand": "LIFAN" }, { "id": 127, "brand": "LOBINI" }, { "id": 35, "brand": "Lotus" }, { "id": 140, "brand": "Mahindra" }, { "id": 36, "brand": "Maserati" }, { "id": 37, "brand": "Matra" }, { "id": 38, "brand": "Mazda" }, { "id": 211, "brand": "Mclaren" }, { "id": 39, "brand": "Mercedes-Benz" }, { "id": 40, "brand": "Mercury" }, { "id": 167, "brand": "MG" }, { "id": 156, "brand": "MINI" }, { "id": 41, "brand": "Mitsubishi" }, { "id": 42, "brand": "Miura" }, { "id": 43, "brand": "Nissan" }, { "id": 44, "brand": "Peugeot" }, { "id": 45, "brand": "Plymouth" }, { "id": 46, "brand": "Pontiac" }, { "id": 47, "brand": "Porsche" }, { "id": 185, "brand": "RAM" }, { "id": 186, "brand": "RELY" }, { "id": 48, "brand": "Renault" }, { "id": 195, "brand": "Rolls-Royce" }, { "id": 49, "brand": "Rover" }, { "id": 50, "brand": "Saab" }, { "id": 51, "brand": "Saturn" }, { "id": 52, "brand": "Seat" }, { "id": 183, "brand": "SHINERAY" }, { "id": 157, "brand": "smart" }, { "id": 125, "brand": "SSANGYONG" }, { "id": 54, "brand": "Subaru" }, { "id": 55, "brand": "Suzuki" }, { "id": 165, "brand": "TAC" }, { "id": 56, "brand": "Toyota" }, { "id": 57, "brand": "Troller" }, { "id": 58, "brand": "Volvo" }, { "id": 59, "brand": "VW - VolksWagen" }, { "id": 163, "brand": "Wake" }, { "id": 120, "brand": "Walk" }]
  }),

  methods: {
    checkAction() {
      if (!this.user?._id) this.dialogSubscribe = true;
    },

    logout() {
      Api.logout();
    },

    setLoading(loading) {
      this.showLoading = loading;
    },

    updateUser(user) {
      this.user = user;
    },

    openSubscribeLink() {
      window.open(this.subscribeLink, '_self');
    }
  },

  created() {
    if (!window.localStorage.getItem('did')) {
      window.localStorage.setItem('did', uuidv4());
    }

    this.termos = getTerms();
    this.dicas = getDicas();
    this.sobre = getSobre();

    this.$root.$refs.global = this;
  },


  async mounted() {
    this.user = Api.getUser();

    if (this.user && this.user._id) this.user = await Api.getRemoteUser({ did: window.localStorage.getItem('did') });
    this.$vuetify.breakpoint.lgAndUp ? (this.drawer = true) : (this.drawer = false);
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.bar-menu-item-title {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.menu-page-container {
  background-color: #eaeaea;
}

.toolbar {
  font-weight: 700;
  color: black;
}

.drawer {
  background: rgb(0, 0, 0);
  background: linear-gradient(180deg, #123cd7 0%, #123cd7 10%, #123cd7 30%, #1a66db 86%);
  z-index: 100;
}

.icon {
  color: #b8b8b8;
}

.item_icon {
  margin-right: 16px !important;
}

.logo {
  position: relative;
  margin-top: 30px;
  margin-bottom: 25px;
  display: flex;
  justify-content: center;
  width: 100%;
}

.menu-item {
  color: white;
  font-weight: 700 !important;
  text-overflow: none !important;
}

.loading-bar {
  position: absolute;
  z-index: 99999 !important;
}

.avatar_container {
  margin-bottom: 10px;
}

.avatar {
  margin-top: 15px;
  margin-bottom: 10px;
}

.rotate_icon {
  transform: rotate(90deg);
}

.toolbar-subtitle {
  font-size: 16px;
  font-weight: 500;
}

.bar-car-details {
  background: linear-gradient(145deg, #111127 0%, #1d388b 96%);
  border-radius: 0px !important;
}
</style>
